import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { EntityTypeCardsProvider, PageLayoutStandard, SiteHeaderProvider } from '@shapeable/ui';
import { LinkCardTownTeam } from '../entities/link-card-town-team';

// -------- Styles -------->

const LayoutStyles = breakpoints({
  base: css`
    
  `
});

// -------- Components -------->

const My = {
  Layout: styled(PageLayoutStandard)`${LayoutStyles}`,
};

export const PageLayoutTownTeams: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;

  return (
    <SiteHeaderProvider value={{
      variant: 'default', // setting variant to overlay keeps the login utility button icon and text white...
      boundary: 'content'
    }}>
    <EntityTypeCardsProvider value={{
      Link: LinkCardTownTeam
    }}>
      <My.Layout 
        className={className}
        entity={entity}
        slices={slices}
        headerProps={{ 
          aspectRatio: { base: 16/9, desktop: 16/9 },
          showOverlayGradient: true,
          fadeColor: '#0000000', 
          overlayColor: '#00000011',
          // backgroundColor: '#0000000',
          useBackgroundColor: true }} 
      />
    </EntityTypeCardsProvider>
    </SiteHeaderProvider>
  )
};


